import React, { useState } from 'react';
import axios from '../../api/api';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const AddAdmin = () => {
  
  const [first_name, setFirst_Name] = useState('');
  const [last_name, setLast_Name] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Add new User
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Password should have a minimum of 8 characters.")
    }
    if (password !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/users/',
        { first_name, last_name, email, phone, role, password }
      );
      toast.success('Admin added successfully!');
      navigate('/admins');
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400 || 401) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to add user.')
      }
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  return (
    <div className='mx-auto p-4 flex justify-center'>
      <div className='p-4 bg-white rounded-lg w-full lg:w-full xl:w-1/2'>
        <h3 className='text-xl text-center font-bold text-[#134463]'>Add New Admin.</h3>
        <form onSubmit={handleSubmit}>
          <div className='mt-2'>
            <label htmlFor='fullname'>First Name
              <input
                type='text'
                required
                placeholder='First Names'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={first_name}
                onChange={(e) => setFirst_Name(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='fullname'>Last Name
              <input
                type='text'
                required
                placeholder='Last Names'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={last_name}
                onChange={(e) => setLast_Name(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='Email'>Email
              <input
                type='email'
                required
                placeholder='example@gmail.com'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='Phone'>Phone
              <input
                type='number'
                required
                placeholder='0700000000'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='role'>User Role
              <select
                first_name='role' id='role'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                required
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value=''>Choose Role</option>
                <option value='ADMIN'>Admin</option>
                <option value='USER'>User</option>
              </select>
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='Password'>Password <i className='text-red-500'>(Min 8 characters)</i>
              <input
                type='password'
                required
                placeholder='Password'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='confirm Password'>Confirm Password
              <input
                type='password'
                required
                placeholder='Confirm Password'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </label>
          </div>
          <div className='py-3'>
            <button type='submit' disabled={loading} className='bg-[#2b1e3e] text-white px-5 py-1 w-full rounded-md hover:bg-[#134463]'>{loading ? 'Please wait...' : 'Add User'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdmin;
